<template>
  <div class="mobile__menu">
      <ul class="nav">
          <li class="nav-item" @click="toggleMobileSidebars(true)" v-if="!showSubSidebar"><i class="fa fa-bars" aria-hidden="true"></i></li>
          <li class="nav-item active" @click="toggleMobileSidebars(false)" v-if="showSubSidebar"><i class="fa fa-times" aria-hidden="true"></i></li>
          <li class="nav-item" :class="{'active': subIsActive('usage')}">
              <router-link :to="{name: 'usage'}"><i class="fa fa-bar-chart" aria-hidden="true"></i></router-link>
          </li>
          <li class="nav-item action__button">
              <svg viewBox="0 0 54 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs></defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Combined-Shape" points="26.6536121 0 0 16.161938 1.91090838e-15 47.6042861 27.184504 63.2045455 54 47.6082479 54 16.0628717"></polygon>
                </g>
              </svg>
          </li>
          <li class="nav-item" :class="{'active': subIsActive(['billing', 'invoice'])}">
              <router-link :to="{name: 'billing'}"><i aria-hidden="true" class="fa fa-credit-card"></i></router-link>
          </li>
          <li class="nav-item" :class="{'active': subIsActive(['team', 'invoice'])}">
              <router-link :to="{name: 'team'}">Team</router-link>
          </li>
      </ul>
  </div>
</template>

<script>
export default {
      computed: {
          showSubSidebar() {
              return this.$store.state.misc.showSidebar;
          },
      },

      created() {
          this.$store.commit('misc/SHOW_SUB_SIDEBAR', this.$store.state.misc.showSidebar);
      },

      methods: {
          toggleMobileSidebars(val) {
              this.$store.commit('misc/SHOW_SIDEBAR', val);
              this.$store.commit('misc/SHOW_SUB_SIDEBAR', val);
          },

          subIsActive(input) {
              const paths = Array.isArray(input) ? input : [input];
              return paths.some(path => {
                if (this.$route.meta.sidebar) {
                    return this.$route.meta.sidebar.indexOf(path) > -1;
                }
              });
          },
      },
}
</script>
